import { addMessages, init, getLocaleFromNavigator } from 'svelte-i18n';

import {en} from './en.js';
import {sv} from './sv.js';
import {pl} from './pl.js';
import {hu} from './hu.js';
import {es} from './es.js';
import {el} from './el.js';
import {nb} from './nb.js';
import {nn} from './nn.js';
import {de} from './de.js';

import {cs} from './cs.js';
import {da} from './da.js';
import {fi} from './fi.js';
import {fr} from './fr.js';
import {pt} from './pt.js';
import {sk} from './sk.js';

const run = () => {
  addMessages('en', en);
  addMessages('nb', nb);
  addMessages('nn', nn);
  addMessages('de', de);
  addMessages('el', el);
  addMessages('sv', sv);
  addMessages('pl', pl);
  addMessages('hu', hu);
  addMessages('es', es);

  addMessages('cs', cs);
  addMessages('da', da);
  addMessages('fi', fi);
  addMessages('fr', fr);
  addMessages('pt', pt);
  addMessages('sk', sk);

  init({
    fallbackLocale: 'en',
    initialLocale: getLocaleFromNavigator(),
  });
}

export {run}
